import { Card, Metric } from "@peer-start/ui";
import { MessagesSquare, Repeat, Users } from "lucide-react";
import { useTranslation } from "react-i18next";
import {
  activeUserPercentage,
  averageConversationsPerUser,
  returningUserPercentage,
} from "../data/manager-insights.js";

export function ManagerUsageMetrics() {
  const { t, i18n } = useTranslation();
  const average = new Intl.NumberFormat(i18n.language, {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  });
  const hint = t("managerDashboard.usage.tooltip");

  return (
    <section aria-label={t("managerDashboard.usage.title")} data-control-id="manager.dashboard.usage">
      <div className="grid gap-4 md:grid-cols-3">
        <Card data-control-id="manager.dashboard.active-users" padding="compact">
          <Metric
            icon={<Users aria-hidden="true" className="size-5" />}
            label={t("managerDashboard.usage.active")}
            tooltip={{
              controlId: "manager.dashboard.active-users.tooltip",
              label: hint,
              text: t("managerDashboard.usage.activeTooltip"),
            }}
            value={t("managerDashboard.usage.percent", { value: activeUserPercentage() })}
          />
        </Card>
        <Card data-control-id="manager.dashboard.returning-users" padding="compact">
          <Metric
            icon={<Repeat aria-hidden="true" className="size-5" />}
            label={t("managerDashboard.usage.returning")}
            tooltip={{
              controlId: "manager.dashboard.returning-users.tooltip",
              label: hint,
              text: t("managerDashboard.usage.returningTooltip"),
            }}
            value={t("managerDashboard.usage.percent", { value: returningUserPercentage() })}
          />
        </Card>
        <Card data-control-id="manager.dashboard.conversations" padding="compact">
          <Metric
            icon={<MessagesSquare aria-hidden="true" className="size-5" />}
            label={t("managerDashboard.usage.conversations")}
            tooltip={{
              controlId: "manager.dashboard.conversations.tooltip",
              label: hint,
              text: t("managerDashboard.usage.conversationsTooltip"),
            }}
            value={average.format(averageConversationsPerUser())}
          />
        </Card>
      </div>
    </section>
  );
}
